import { InfoIcon } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/ui/tooltip';

const PermissionTooltip = () => {
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="shrink-0 cursor-pointer">
            <InfoIcon className="size-3" />
          </div>
        </TooltipTrigger>
        <TooltipContent side="bottom" align="center" className="max-w-75 text-sm">
          <p>
            <strong>Manager</strong> — Full control: settings, members, and protections (including agreements and
            deposits).
            <br />
            <strong>Viewer</strong> — Read-only access.
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default PermissionTooltip;
